import Service from './Service';

export default class ExternalResolutionMapService extends Service{
    constructor() {
        super();
        this.baseURL = 'externalResolutionMap';
    }

}